
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/distribucion",
      function () {
        return require("private-next-pages/distribucion/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/distribucion"])
      });
    }
  